import React, { useState, useEffect } from 'react';
import { Flex, Input, Modal, List, Checkbox, Button } from 'antd';
import { SwapOutlined, AppstoreAddOutlined } from '@ant-design/icons';

export default (props) => {
    const { title = '', children, id, value, defaultValue, onChange = () => {} } = props;
    const [shops, setShops] = React.useState([]);
    const [selectedShops, setSelectedShops] = React.useState([]);
    const [currentShops, setCurrentShops] = React.useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const modalRef = React.useRef(null);

    // console.log('value', value);
    // setSelectedShops(...value);
    const triggerChange = (changedValue) => {
        onChange?.(changedValue);
    };

    const onShopsChange = (e) => {
        // const newNumber = parseInt(e.target.value || '0', 10);
        // if (Number.isNaN(number)) {
        //     return;
        // }
        // if (!('number' in value)) {
        //     setNumber(newNumber);
        // }
        // triggerChange({
        //     number: newNumber,
        // });
    };

    // 同步状态与参数 
    useEffect(() => {
        getShops();
    }, []);

    useEffect(() => {
        setSelectedShops(value);
        setCurrentShops(value);
        console.log('defaultValue', value);
    }, [value]);

    const getShops = async () => {
        const accId = window.__baseInfo.accId;
        let response = await fetch(`/api/shop/my-permission-list?accId=${accId}&status=1`);
        let result = await response.json();

        if(result && result.success) {
            setShops(result.data);
        }
    }

    const openShopsSelector = () => {
        setIsOpen(true);
    }

    const onOk = () => {
        setCurrentShops([...selectedShops]);
        triggerChange([...selectedShops]);
        setIsOpen(false);
    }

    const onShopChange = (e, shop) => {
        console.log('onShopChange', e.target.checked, shop);
        const checkd = e.target.checked;
        if(checkd) {
            setSelectedShops(prev => {
                return [...(prev || []), {shopId: shop.shopId, title: shop.title}];
            });
        }else {
            setSelectedShops(prev => {
                return (prev || []).filter(item => item.shopId !== shop.shopId);
            });
        }
    }

    const handleShopDelete = (shopId) => {
        const newShops = currentShops.filter(item => item.shopId !== shopId);
        setSelectedShops([...newShops]);
        setCurrentShops([...newShops]);
        triggerChange([...newShops]);
    }

    return (
        <div>
            <Modal title='请选择店铺' open={isOpen} onOk={onOk} centered onCancel={() => setIsOpen(false)} destroyOnClose={true}>
                <div ref={modalRef} style={{ minHeight: '30vh', overflow: 'auto'}}>
                    <Input.Search placeholder='搜索店铺名' />
                    <List
                        // header={<div>Header</div>}
                        // footer={<div>Footer</div>}
                        // bordered
                        dataSource={shops}
                        renderItem={(item) => {
                            // selectedShops
                            // console.log('selectedShops', selectedShops)
                            let defaultChecked = (selectedShops || []).find(shop => shop.shopId === item.shopId);

                            return (
                                <label><List.Item onClick={() => (item)} key={item.shopId}>
                                    <Checkbox data-shop={JSON.stringify(item)} onChange={(e) => onShopChange(e, item)} defaultChecked={defaultChecked}></Checkbox> {item.title}
                                </List.Item></label>
                            )
                        }}
                    />
                </div>
            </Modal>
            {/* <Input type="hidden" value={value} onChange={onShopsChange} /> */}
            {
                currentShops && <List bordered dataSource={currentShops}  style={{margin: '0 0 10px 0'}} renderItem={
                    (item) => <List.Item actions={[<a onClick={() => handleShopDelete(item.shopId)}>删除</a>]} key={item.shopId}>{item.title}</List.Item>
                } />
            }
            <div><span onClick={openShopsSelector}>{children ? children : <Button>选择店铺</Button>}</span></div>
            
        </div>
    )
}